"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgCountryEditor_1 = require("./component/CfgCountryEditor");
var CfgCountryList_1 = require("./component/CfgCountryList");
var CfgCountryLocaleEditor_1 = require("./component/locales/CfgCountryLocaleEditor");
var CfgCountryLocalesList_1 = require("./component/locales/CfgCountryLocalesList");
var CfgCountryListBase_1 = require("./lang/CfgCountryListBase");
var PCfgCountryList = /** @class */ (function (_super) {
    __extends(PCfgCountryList, _super);
    function PCfgCountryList(props) {
        return _super.call(this, props) || this;
    }
    PCfgCountryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.SID_AL = this.props.availLanguages.Subscribe("*", function (id, data) {
            _this.setState({
                data_lang: data.data
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            lang: CfgCountryListBase_1.CfgCountryListLangFactory.getLangInstance(this.props.state.getLang()),
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            data_lang: []
        }, function () {
            _this.props.availLanguages.LoadData();
        });
    };
    PCfgCountryList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.availLanguages.UnSubscribe(this.SID_AL);
    };
    PCfgCountryList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgCountryList.prototype.onNewLocaleClick = function () {
        this.setState({ edit_mode: "NEW-LOCALE", recordLocale: null });
    };
    PCfgCountryList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgCountryList.prototype.onEditLocaleClick = function (id) {
        this.setState({ edit_mode: "EDIT-LOCALE", recordLocale: id });
    };
    PCfgCountryList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgCountryList.prototype.onGoBackToLocalesListClick = function () {
        this.setState({ edit_mode: "LIST-LOCALE", recordLocale: null });
    };
    PCfgCountryList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgCountryList.prototype.onGoToLocaleListClick = function (id) {
        this.setState({ edit_mode: "LIST-LOCALE", record: id });
    };
    PCfgCountryList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgCountryEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), lang: this.state.lang }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgCountryEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), lang: this.state.lang }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgCountryList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onEditLocaleClick: this.onGoToLocaleListClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, lang: this.state.lang }));
        }
        if (this.state.edit_mode === "NEW-LOCALE") {
            return (React.createElement(CfgCountryLocaleEditor_1.default, { data: this.props.dataLocales, state: this.props.state, rootRecord: this.state.record, onGoBack: this.onGoBackToLocalesListClick.bind(this), record: null, availLanguage: this.state.data_lang }));
        }
        if (this.state.edit_mode === "EDIT-LOCALE") {
            return (React.createElement(CfgCountryLocaleEditor_1.default, { data: this.props.dataLocales, state: this.props.state, rootRecord: this.state.record, onGoBack: this.onGoBackToLocalesListClick.bind(this), record: this.state.recordLocale, availLanguage: this.state.data_lang }));
        }
        if (this.state.edit_mode === "LIST-LOCALE") {
            return (React.createElement(CfgCountryLocalesList_1.default, { data: this.props.dataLocales, state: this.props.state, onNewClick: this.onNewLocaleClick.bind(this), onEditClick: this.onEditLocaleClick.bind(this), rootRecord: this.state.record, onGoBackClick: this.onGoBackClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgCountryList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgCountryList.getPageDescription = function (state) {
        var lang = CfgCountryListBase_1.CfgCountryListLangFactory.getLangInstance("RU"); //state.getLang()
        return {
            icon: "atlas",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_country_config + "-id",
            itemTitle: lang.document_title,
            route: routes_1.routes.page_config_country_config,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgCountryList;
}(React.Component));
exports.default = PCfgCountryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/PCfgCountryList.tsx
// module id = 2049
// module chunks = 0